import React, { FC, useState } from "react";
import { t } from "i18next";

import WelcomeBanner from "@components/common/WelcomeBanner";
import { Grid } from "@components/base";

interface ProcurementWelcomeBannerInterface {}

const ProcurementWelcomeBanner: FC<ProcurementWelcomeBannerInterface> = () => {
  const [show, setShow] = useState(true);

  const onClose = (): void => {
    setShow(false);
  };

  return show ? (
    <Grid size={12}>
      <WelcomeBanner
        color="blue"
        title={t("csob.supplier.welcomeBannerTitle")}
        text={t("csob.supplier.welcomeBannerDescription")}
        icon="data-cloud"
        onClose={onClose}
      />
    </Grid>
  ) : null;
};

export default ProcurementWelcomeBanner;
